/** Prefix the backend writes in front of a blocker's reason. */
const BLOCKER_REASON_MARKER = 'Grund: ';
/** Boilerplate comment a blocker created without a reason carries. */
const BLOCKER_DEFAULT_COMMENT = 'Dies ist ein Blocker';

/**
 * The reason a timeslot was blocked, taken out of the blocker's comment
 * ("Zeitraum blockiert. Grund: <reason>"). Blockers created without a reason
 * carry a generic boilerplate sentence instead, which says nothing and is
 * dropped.
 */
export const blockerReason = comment => {
  const value = String(comment || '').trim();
  const idx = value.indexOf(BLOCKER_REASON_MARKER);
  if (idx >= 0) return value.slice(idx + BLOCKER_REASON_MARKER.length).trim();
  return value.startsWith(BLOCKER_DEFAULT_COMMENT) ? '' : value;
};
